import * as React from 'react';

export const YoutubeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#A84DFF"
      d="M15 25.625c2.262 0 4.431-.224 6.442-.633 2.51-.512 3.767-.768 4.912-2.241 1.146-1.473 1.146-3.164 1.146-6.547v-2.408c0-3.383 0-5.074-1.146-6.547-1.145-1.473-2.401-1.729-4.912-2.24-2.01-.41-4.18-.634-6.442-.634-2.262 0-4.431.223-6.442.633-2.51.512-3.766.768-4.912 2.241S2.5 10.413 2.5 13.796v2.408c0 3.383 0 5.074 1.146 6.547 1.146 1.473 2.401 1.729 4.912 2.24 2.01.41 4.18.634 6.442.634Z"
    />
    <path
      fill="#710ED0"
      d="M19.953 15.391c-.186.757-1.173 1.301-3.147 2.39-2.147 1.182-3.22 1.774-4.09 1.546a2.114 2.114 0 0 1-.793-.397c-.673-.544-.673-1.673-.673-3.93s0-3.386.672-3.93c.228-.184.5-.32.794-.397.87-.228 1.943.364 4.09 1.547 1.974 1.088 2.961 1.632 3.147 2.389a1.64 1.64 0 0 1 0 .782Z"
    />
  </svg>
);
